export default "__VITE_ASSET__CJJqV52n__"